import React, { Component } from "react";
import * as ReactDOM from "react-dom";
import $ from "jquery";
import Button from "react-bootstrap-button-loader";
import { connect } from "react-redux";
import _ from "lodash";
import { Field, reduxForm, formValueSelector, reset } from "redux-form";
import { Modal, Row, Col, Tabs, Tab } from "react-bootstrap";
import moment from "moment-timezone";
import StarRatings from "react-star-ratings";
import Select from "react-select";
import QRCode from "qrcode";
import { jsPDF } from "jspdf";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { parse, format } from "date-fns";
import { confirmAlert } from "react-confirm-alert";
import { CopyToClipboard } from "react-copy-to-clipboard";
import PDFObject from "pdfobject";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  openDashboardUserModal,
  addAppUser,
  editDashboardUser,
  updateUser,
  openUserCategoryModal,
  sendWelcomeMail,
  deleteDashboardUser,
  fetchPasscode,
  uploadUserattachments,
  sendShortlistedEmail,
  getScannedItems,
} from "DashboardUserAction";
import {
  validateEmailForAppUser,
  validateEmailFromSystemDB,
  checkemailinSytemDB,
} from "DashboardMenuAction";
import { insertSpeaker, fetchAllSpeakers } from "ActionsSpeakers";
import { fetchAllBadgeList, generateBadges } from "BadgeDesignAction";
import {
  BASE_IMAGES_URL,
  COMMON_FAIL_MESSAGE,
  validateEmail,
  converDateIntoLocal,
  DEVELOPMENT_TYPE,
  DATE_FORMAT_FNS,
  classNames,
  validateSocialMediaUrl,
  ACCESS_FILES_API_KEY,
  DISPLAY_LOCAL_DATE_FORMAT,
  checkDateFormatYMD,
  DATE_FORMAT,
  MAIN_URL,
} from "Constants";
import {
  DEFAULTFONTSIZE,
  DEFAULTFONTFAMILY,
  DEFAULTFONTWEIGHT,
} from "BadgeConstant";
import { convertToPixel } from "BaseFunctions";
import AppIcons from "AppIcons";
import ImageCropper from "ImageCropper";
import Loader from "Loader";
import MaxCharacterObject from "MaxCharacterObject";
import LocaleStrings from "Languages";
import ListItem from "../../settings/components/email-log/list-item";

var MAXLENOBJ = {};
class AddUserDialog extends BaseComponent {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.state = {
      loading: false,
      selectedTab: 1,
      fileName: "",
      fileArr: [],
      scanloading: false,
    };
  }

  componentDidUpdate(prevState) {
    if (prevState.initialValues !== this.props.initialValues) {
      if (this.props.initialValues.hasOwnProperty("userattachments")) {
        if (this.props.initialValues.userattachments !== null) {
          var namesArray = this.props.initialValues.userattachments.split(",");
          var items = [];
          for (var i = 0; i < namesArray.length; i++) {
            let item = {};
            let trim_name = `eventify/${prevState.session.eventid}/images/appusers/`;
            let trimName_length = trim_name.length;
            let namesArraylength = namesArray[i].length;

            item.name = namesArray[i].substr(trimName_length, namesArraylength);

            items.push(item);
          }

          this.setState({ fileArr: items });
        }
      }
    }
  }

  openModal() {
    this.props.reset();
    this.setState({ loading: false, selectedTab: 1 });
    this.props.editDashboardUser({});
    this.props.openDashboardUserModal(true);

    $(".user-main-backdrop-modal").removeClass("hide");
    $(".user-main-backdrop-modal").addClass("show");
  }

  closeModal() {
    this.setState({ fileArr: [], selectedTab: 1 });
    this.props.openDashboardUserModal(false);

    $(".user-main-backdrop-modal").removeClass("show");
    $(".user-main-backdrop-modal").addClass("hide");
  }

  handleSelect(key) {
    this.setState({ selectedTab: key });
  }

  onManageUserCategory = () => {
    this.props.openDashboardUserModal(false);
    this.props.openUserCategoryModal(true);
    this.setState({ selectedTab: 1 });
  };

  onSubmitForm(data) {
    let eventid = this.props.session.eventid;
    if (data.hasOwnProperty("facebook")) {
      data["facebook"] = data.facebook.replaceAll(/\s/g, "");
    }
    if (data.hasOwnProperty("linkedin")) {
      data["linkedin"] = data.linkedin.replaceAll(/\s/g, "");
    }
    if (data.hasOwnProperty("twitter")) {
      data["twitter"] = data.twitter.replaceAll(/\s/g, "");
    }

    // console.log("data :- ", data);

    // debugger;
    let attachmentNames = [];
    let uploaderCounter = 0;
    let filetobeupload = [];
    let arrPromise = [];

    if (this.state.fileArr.length > 0) {
      _.forEach(this.state.fileArr, function (value, index) {
        attachmentNames.push(
          `eventify/${eventid}/images/appusers/${value.name}`
        );

        let coverJson = {
          type: value.type,
          name: value.name,
          media: value.url,
        };

        filetobeupload.push(coverJson);
      });

      let counter = filetobeupload.length;

      filetobeupload.map((item, index) => {
        arrPromise.push(
          new Promise((resolve, reject) => {
            this.props.uploadUserattachments(
              this.props.session,
              item,
              (response) => {
                if (response.success === 0) {
                  resolve();
                } else {
                  uploaderCounter++;
                  resolve();
                }
              }
            );
          })
        );
      });

      data["userattachments"] = _.join(attachmentNames, ",");
    }

    var { userCategoryList } = this.props;
    var eventForm =
      this.props.settingData &&
      this.props.settingData.length > 0 &&
      this.props.settingData[0].event_forms_by_eventformid
        ? JSON.parse(
            this.props.settingData[0].event_forms_by_eventformid.formjson
          )
        : [];
    var eventFormID =
      this.props.settingData && this.props.settingData.length > 0
        ? this.props.settingData[0].eventformid
        : null;
    if (this.props.editMode && data.comesfrom == "ticket") {
      var matchedTicket = _.filter(this.props.ticketList, (ticket) => {
        return ticket.id == data.ticketid;
      });

      if (matchedTicket.length > 0 && matchedTicket[0].event_forms_by_formid) {
        eventForm = JSON.parse(matchedTicket[0].event_forms_by_formid.formjson);
        eventFormID = matchedTicket[0].formid;
      }
    }
    var array = [];
    var values = {};
    var mainFields = [
      "profileimagehidden",
      "coverimagehidden",
      "email",
      "firstname",
      "lastname",
      "userpassword",
      "userinterests",
      //"userattachments",
    ];

    // Creating values as required to store in separate column
    _.map(mainFields, (main) => {
      if (data.hasOwnProperty(main)) {
        if (main === "userinterests") {
          values[main] = _.uniqBy(data[main]); // Its comes in array so by any chance if any interest id is duplicate, here we are removing.
        } else {
          values[main] = data[main];
        }
      }
    });

    if (eventForm.length > 0) {
      _.map(eventForm, (form, index) => {
        var name = form.name;
        var formKey = form.key;

        if (
          formKey !== "label" &&
          formKey !== "hyperlink" &&
          formKey !== "paragraph" &&
          formKey !== "section"
        ) {
          if (data.hasOwnProperty(name)) {
            if (formKey === "datepicker") {
              let date = "";
              if (data[name]) {
                if (typeof data[name] === "string") {
                  if (checkDateFormatYMD(data[name])) {
                    date = moment(data[name]).format(DATE_FORMAT);
                  } else {
                    date = moment(data[name], DISPLAY_LOCAL_DATE_FORMAT).format(
                      DATE_FORMAT
                    );
                  }
                  if (!moment(date).isValid()) {
                    date = "";
                  }
                } else {
                  date = moment(data[name]).format(DATE_FORMAT);
                }
              }

              form.value = date;
            } else {
              form.value = data[name];
            }
          } else {
            form.value = "";
            if (formKey === "checkboxes") {
              form.value = [];
            }
          }
        }
        array.push(form);
      });
    }

    // User category related section start
    var res = data.primarycategory != "" ? data.primarycategory : "";
    let userCat = data.othercategory;
    if (userCat && Array.isArray(userCat) && userCat.length > 0) {
      let tags = _.map(userCat, (el) => {
        return el.value;
      });

      var othrcat = tags.join(",");
      res = res !== "" ? res + "," + othrcat : othrcat;
    } else if (userCat && !Array.isArray(userCat)) {
      res = res !== "" ? res + "," + userCat : userCat;
    }

    if (res === "") {
      var attendee = _.filter(userCategoryList.data, (obj) => {
        return obj.type == "attendee";
      });
      res = attendee[0].id.toString();
    }

    var adminDetails = _.filter(userCategoryList.data, (obj) => {
      return obj.type == "admin";
    });
    var isAdmin =
      //adminDetails.length > 0 ? res.value.search(adminDetails[0].id) : -1;
      adminDetails.length > 0 ? res.search(adminDetails[0].id) : -1; // Old
    // User category related section end

    // User status related section start
    var useractive = 1;
    var userwaitlist = 0;
    if (data.userstatus === "confirmed") {
      useractive = 1;
      userwaitlist = 0;
    } else if (data.userstatus === "waitlist") {
      useractive = 1;
      userwaitlist = 1;
    } else if (data.userstatus === "inactive") {
      useractive = 0;
      userwaitlist = 0;
    }

    values.isactive = useractive;
    values.userwaitlistmode = userwaitlist;
    // User status related section end

    values.usercategory = res;
    values.username = data.firstname + " " + data.lastname;
    values.isnetworking = data.isnetworking ? 1 : 0;
    values.isadmin = isAdmin >= 0 ? 1 : 0;
    values.responses = JSON.stringify(array);
    values.formid = eventFormID;
    values.speakeridfk =
      data.speakeridfk && data.speakeridfk.speakerid
        ? data.speakeridfk.speakerid
        : data.speakeridfk
        ? data.speakeridfk
        : null;
    values.sponsoridfk =
      data.sponsoridfk && data.sponsoridfk.sponsorid
        ? data.sponsoridfk.sponsorid
        : data.sponsoridfk
        ? data.sponsoridfk
        : null;
    values.exhibitoridfk =
      data.exhibitoridfk && data.exhibitoridfk.exhibitorid
        ? data.exhibitoridfk.exhibitorid
        : data.exhibitoridfk
        ? data.exhibitoridfk
        : null;

    if (data.hasOwnProperty("userattachments")) {
      values.userattachments = data.userattachments;
    }

    // console.log("final values :- ", values);

    if (!this.props.editMode) {
      // Add

      values.userpassword = data.userpassword ? data.userpassword : "";

      this.setState({ loading: true });
      this.props.validateEmailForAppUser(
        this.props.session,
        values,
        (validationresponse) => {
          if (validationresponse.success === 2) {
            this.props.showError(validationresponse.message);
            this.setState({ loading: false });
          } else if (validationresponse.success == 1) {
            // Check if appuser wants to add as speaker too, then add as speaker
            if (data.createspeaker) {
              var speakerbody = {
                permittedusers: "",
                eventid: this.props.session,
                firstname: data.firstname,
                lastname: data.lastname,
                email: data.email,
                position: data.designation ? data.designation : null,
                company: data.company ? data.company : null,
                country: data.country ? data.country : null,
                phone: data.phonenumber ? data.phonenumber : null,
                facebook: data.facebook ? data.facebook : null,
                linkedin: data.linkedin ? data.linkedin : null,
                twitter: data.twitter ? data.twitter : null,
              };

              this.props.insertSpeaker(
                this.props.session,
                speakerbody,
                {},
                null,
                {},
                [],
                (result) => {
                  if (result.speakerid) {
                    values.speakeridfk = result.speakerid;
                  }
                  this.props.addAppUser(
                    this.props.session,
                    values,
                    (response) => {
                      if (response.success === 0) {
                        this.setState({ loading: false });
                        this.props.showError(COMMON_FAIL_MESSAGE);
                      } else if (response.success === 2) {
                        this.setState({ loading: false });
                        this.props.showError(
                          LocaleStrings.user_message_user_imageupload_error
                        );
                      } else {
                        this.props.fetchAllSpeakers(
                          this.props.session,
                          (res) => {
                            this.props.showSuccess(
                              LocaleStrings.user_message_user_added
                            );
                            this.setState({ fileArr: [] });
                            this.setState({ loading: false });
                            this.props.finishOperationsCallback();
                            this.closeModal();
                          }
                        );

                        // Check Admin want to send email too
                        if (data.sendwelcomeemail) {
                          this.props.sendWelcomeMail(this.props.session, {
                            email: values.email,
                            userstatus: data.userstatus,
                          });
                        }
                      }
                    }
                  );
                }
              );
            } else {
              this.props.addAppUser(this.props.session, values, (response) => {
                this.setState({ loading: false });
                if (response.success === 0) {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else if (response.success === 2) {
                  this.props.showError(
                    LocaleStrings.user_message_user_imageupload_error
                  );
                } else {
                  this.props.showSuccess(LocaleStrings.user_message_user_added);
                  this.setState({ fileArr: [] });
                  this.props.finishOperationsCallback();
                  this.closeModal();

                  // Check Admin want to send email too
                  if (data.sendwelcomeemail) {
                    this.props.sendWelcomeMail(this.props.session, {
                      email: values.email,
                      userstatus: data.userstatus,
                    });
                  }
                }
              });
            }
          } else {
            this.setState({ loading: false });
            this.props.showError(COMMON_FAIL_MESSAGE);
          }
        }
      );
    } else {
      // Update

      var ustaus = data.userstatus; // waitlist,confirmed
      if (data.userwaitlistmode == true && data.userstatus == "confirmed") {
        ustaus = "waitlist_to_confirmed";
      }

      if (this.props.initialValues.email != values.email) {
        // ~UDAYAN -18-1-2022
        //We need to update System DB as right now we  allowing to change emailid.. and validation is also needed.

        this.setState({ loading: true });
        this.props.validateEmailForAppUser(
          this.props.session,
          values,
          (validationresponse) => {
            if (validationresponse.success === 2) {
              this.props.showError(validationresponse.message);
              this.setState({ loading: false });
            } else if (validationresponse.success == 1) {
              this.props.checkemailinSytemDB(
                this.props.session,
                values,
                (response) => {
                  if (response.success === 1) {
                    values["dfid"] = response.response.dfid;
                    this.props.updateUser(
                      this.props.session,
                      values,
                      this.props.initialValues,
                      (response) => {
                        this.setState({ loading: false });
                        if (response.success === 0) {
                          this.props.showError(COMMON_FAIL_MESSAGE);
                        } else if (response.success === 2) {
                          this.props.showError(
                            LocaleStrings.user_message_user_imageupload_error
                          );
                        } else {
                          this.props.showSuccess(
                            LocaleStrings.user_message_user_updated
                          );
                          this.props.finishOperationsCallback();
                          this.closeModal();

                          // Check Admin want to send email too
                          if (data.sendwelcomeemail) {
                            this.props.sendWelcomeMail(this.props.session, {
                              email: values.email,
                              userstatus: ustaus,
                            });
                          }
                        }
                      }
                    );
                  } else {
                    this.props.showError(validationresponse.message);
                    this.setState({ loading: false });
                  }
                }
              );
            } else {
              this.setState({ loading: false });
              this.props.showError(COMMON_FAIL_MESSAGE);
            }
          }
        );
      } else {
        // ~VED - 25-04-2019
        //We don't need to update System DB as right now we aren't allowing to change emailid.. and validation is also not needed.

        /*this.props.validateEmailForAppUser(this.props.session,values,(validationresponse)=>{
        if(validationresponse.success === 2) {
          this.props.showError(validationresponse.message);
          this.setState({loading:false});
        }
        else if(validationresponse.success == 1) {*/
        this.setState({ loading: true });
        this.props.updateUser(
          this.props.session,
          values,
          this.props.initialValues,
          (response) => {
            this.setState({ loading: false });
            if (response.success === 0) {
              this.props.showError(COMMON_FAIL_MESSAGE);
            } else if (response.success === 2) {
              this.props.showError(
                LocaleStrings.user_message_user_imageupload_error
              );
            } else {
              this.props.showSuccess(LocaleStrings.user_message_user_updated);
              this.setState({ fileArr: [] });
              this.props.finishOperationsCallback();
              this.closeModal();

              // Check Admin want to send email too
              if (data.sendwelcomeemail) {
                this.props.sendWelcomeMail(this.props.session, {
                  email: values.email,
                  userstatus: ustaus,
                });
              }
            }
          }
        );
      }
    }
  }

  _handleUnSelect = (e, i) => {
    var attachmentDeleteItem = this.state.fileArr;
    attachmentDeleteItem.splice(i, 1); // first element removed
    this.setState({ fileArr: attachmentDeleteItem });
    this.props.change(this.props.pristine, false);
  };

  _handleSelect(event) {
    let { fileArr } = this.state;
    if (fileArr.length > 4) {
      this.props.showError("Can upload upto 5 files");
      return false;
    }
    const reader = new FileReader(); // Define reader
    let file = event.target.files[0]; // Take Selected file
    reader.readAsArrayBuffer(file); // Read the file

    // On File Load
    reader.onload = (e) => {
      file.url = e.target.result;
    };

    this.setState({ fileName: file.name });
    //this.props.autofill(typeindex,file.name);

    fileArr.push(file);
    this.setState({ fileArr: fileArr });
    this.props.change(this.props.pristine, false);
  }

  JSONToCSVConvertor(JSONData, ShowLabel) {
    //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var arrData = typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;

    var CSV = "";

    //This condition will generate the Label/Header
    if (ShowLabel) {
      var row = "";
      _.map(arrData, (item) => {
        row += item + "\n";
      });
      row = row.slice(0, -1);

      //append Label row with line break
      CSV += row + "\r\n";
    }

    if (CSV == "") {
      alert("Invalid data");
      return;
    }

    //Generate a file name
    var fileName = "ScanItems";

    //Initialize file format you want csv or xls
    var uri = "data:text/csv;charset=utf-8," + escape(CSV);

    // Now the little tricky part.
    // you can use either>> window.open(uri);
    // but this will not work in some browsers
    // or you will not get the correct file extension

    //this trick will generate a temp <a /> tag
    var link = document.createElement("a");
    link.href = uri;

    //set the visibility hidden so it will not effect on your web-layout
    link.style = "visibility:hidden";
    link.download = fileName + ".csv";

    //this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  getscanData = () => {
    let { session, initialValues } = this.props;
    this.setState({ scanloading: true });
    this.props.getScannedItems(session, initialValues.appuserid, (response) => {
      //console.log("res", response);
      if (response.success == 1) {
        this.setState({ scanloading: false });
        if (response.data && !_.isEmpty(response.data)) {
          this.setState({ scanloading: false });
          this.JSONToCSVConvertor(response.data, true);
        } else {
          this.props.showError(LocaleStrings.no_data_found);
        }
      } else {
        this.setState({ scanloading: false });
      }
    });
  };

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      settingData,
      actionAppModules,
      editMode,
      initialValues,
    } = this.props;
    let { fileArr } = this.state;

    let moduleTicket = [];
    if (actionAppModules && actionAppModules.length > 0) {
      moduleTicket = _.filter(actionAppModules, (app) => {
        return app.iconName == "tickets";
      });
    }

    var fileStyle = {
      paddingRight: "10px",
      marginRight: "10px",
      border: "1px solid #e6edf3",
      padding: "10px",
      background: "#fff",
      width: "100%",
    };

    return (
      <div>
        <span className="">
          <button
            type="button"
            className="btn btn-custom-blue"
            onClick={this.openModal}
          >
            {/* <i className="fa fa-plus i-custom-m"></i>{LocaleStrings.button_add_user} */}
            <img
              style={{ paddingRight: 8, paddingBottom: 3 }}
              src="../../style/images/header-icons/plus.png"
              alt="plus-icon"
            />
            {LocaleStrings.button_add_user}
          </button>
        </span>
        <div>
          <Modal
            className="user-main-dialog"
            backdropClassName="user-main-backdrop-modal"
            show={this.props.showModal === true ? true : false}
            onHide={this.closeModal}
            animation={true}
            dialogClassName="add-user-modal"
            data-dismiss="modal"
          >
            <form
              className="appuser-form"
              onSubmit={handleSubmit(this.onSubmitForm)}
              encType="multipart/form-data"
            >
              <Modal.Header>
                <div className="import-modal-title">
                  {`${
                    editMode ? `${LocaleStrings.edit}` : `${LocaleStrings.add}`
                  } ${LocaleStrings.user}`}
                </div>
                <button
                  type="button"
                  className="i-custom-cross-popup pull-right"
                  onClick={() => this.closeModal()}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                    alt="close"
                  />
                </button>
              </Modal.Header>
              <Modal.Body style={{ padding: "20px" }}>
                <Field
                  name="display_othertab_error"
                  type="text"
                  component={this.renderHiddenFieldText}
                />

                <Tabs
                  className="appuser-add-edit-tab mt-0"
                  id="appuser-from-tab"
                  activeKey={this.state.selectedTab}
                  onSelect={this.handleSelect}
                >
                  <Tab
                    eventKey={1}
                    title={LocaleStrings.user_tab_basic_details}
                  >
                    <div>
                      <AddUserForm
                        editMode={editMode}
                        initialValues={initialValues}
                        {...this.props}
                        onManageCategory={this.onManageUserCategory}
                        closeModals={this.closeModal}
                        passcodeEmail={
                          this.props.passcodeEmail
                            ? this.props.passcodeEmail.data
                            : null
                        }
                      />
                    </div>
                  </Tab>

                  {/* {moduleTicket.length>0 && moduleTicket[0].isenabled ? */}
                  <Tab
                    eventKey={2}
                    title={LocaleStrings.user_tab_other_details}
                  >
                    {settingData &&
                    settingData.length > 0 &&
                    settingData[0].event_forms_by_eventformid ? (
                      <div>
                        <div>
                          <ContactForm
                            settingData={settingData}
                            {...this.props}
                          />
                        </div>
                      </div>
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        <label>
                          {LocaleStrings.user_note_create_dynamic_form}
                        </label>
                      </div>
                    )}
                  </Tab>
                  {/* :
                    null
                  } */}

                  {DEVELOPMENT_TYPE === "koachify" ? (
                    ""
                  ) : (
                    <Tab
                      eventKey={3}
                      title={LocaleStrings.user_tab_access_permission}
                    >
                      <div>
                        <AddUserPermissionForm
                          editMode={this.props.editMode}
                          initialValues={this.props.initialValues}
                          {...this.props}
                        />
                      </div>
                    </Tab>
                  )}
                  {DEVELOPMENT_TYPE === "koachify" ? (
                    ""
                  ) : (
                    <Tab
                      eventKey={4}
                      title={LocaleStrings.user_tab_access_private_docs}
                    >
                      <div>
                        The event host can upload necessary files here and the
                        files will be visible only to the user.{" "}
                        <span style={{ color: "#2776EA" }}>
                          (Users can find the private files from their own
                          profile in the app /web.)
                        </span>
                      </div>
                      <div className="">
                        <div className="" style={{ display: "flex" }}>
                          <span
                            className="text-sm "
                            style={{ color: "#000", width: "100%" }}
                          >
                            {_.size(this.state.fileArr) > 0 ? (
                              <div style={{ marginTop: "10px" }}>
                                <p>
                                  Upload Files{" "}
                                  <span style={{ color: "#2776EA" }}>
                                    (Max. 5 files)
                                  </span>
                                </p>
                                {_.map(this.state.fileArr, (value, index) => {
                                  return (
                                    <div
                                      key={`user_file_key_${index}`}
                                      style={{
                                        display: "flex",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <div
                                        className="user-attachments"
                                        style={fileStyle}
                                      >
                                        <span className="user-doc-upload-file-name">
                                          {value.name}
                                        </span>
                                      </div>

                                      <button
                                        className={classNames(
                                          _.size(this.state.fileArr) > 0
                                            ? "i-custom-table-delete "
                                            : "hidden i-custom-table-delete"
                                        )}
                                        style={{ marginTop: "5px" }}
                                        type="button"
                                        onClick={(e) =>
                                          this._handleUnSelect(e, index)
                                        }
                                      >
                                        <img
                                          className={classNames(
                                            _.size(this.state.fileArr) > 0
                                              ? "i-custom-table"
                                              : "hidden i-custom-table",
                                            "h-4 w-4 cursor-pointer"
                                          )}
                                          src="../../style/images/custom-icons/shape-1317-copy-3.svg"
                                          alt=""
                                        />
                                      </button>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                        {_.size(this.state.fileArr) < 5 ? (
                          <div
                            className="flex"
                            style={{
                              textAlign: "end",
                              cursor: "pointer",
                              marginTop: "5px",
                            }}
                          >
                            <label
                              htmlFor="attachment"
                              className="relative cursor-pointer user-attachments"
                              style={{
                                border: "1px solid #e6edf3",
                                padding: "10px",
                                background: "#fff",
                                cursor: "pointer",
                              }}
                            >
                              <span className="font-icomoon i-custom-ms">
                                {AppIcons.uploadericon}
                              </span>
                              <span>{LocaleStrings.attach_files}</span>
                              <input
                                id="attachment"
                                name="attachment"
                                type="file"
                                // accept="image/*"
                                className="sr-only"
                                onChange={(e) => this._handleSelect(e)}
                              />
                            </label>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div>
                        <Button
                          className="btn btn-custom-blue"
                          loading={this.state.scanloading}
                          onClick={this.getscanData}
                        >
                          {LocaleStrings.export_scanned_items}
                        </Button>
                      </div>
                    </Tab>
                  )}
                  {editMode ? (
                    <Tab
                      eventKey={5}
                      title={LocaleStrings.user_tab_access_badges}
                    >
                      <div>
                        <UserBadge {...this.props} />
                      </div>
                    </Tab>
                  ) : (
                    ""
                  )}
                  {editMode &&
                  initialValues.event_email_logs_by_appuserid &&
                  initialValues.event_email_logs_by_appuserid.length > 0 ? (
                    <Tab eventKey={6} title={"Emails"}>
                      <div>
                        <UserEmailList {...this.props} />
                      </div>
                    </Tab>
                  ) : (
                    ""
                  )}
                </Tabs>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn btn-custom-white"
                  onClick={this.closeModal}
                >
                  {LocaleStrings.button_close}
                </Button>
                <Button
                  className="btn btn-custom-blue ml-10"
                  loading={this.state.loading}
                  disabled={pristine || invalid || submitting}
                  type="submit"
                >
                  {LocaleStrings.button_save}
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </div>
      </div>
    );
  }
}

const selector = formValueSelector("DashboardAddUserForm");

function mapStateToProps(state) {
  var attendee = _.filter(state.userCategoryList.data, (obj) => {
    return obj.type === "attendee";
  });

  var init = {
    userinterests: [],
    primarycategory: attendee.length > 0 ? attendee[0].id.toString() : "",
    othercategory: "",
    userstatus: "confirmed",
  };

  if (!_.isEmpty(state.dashboardUser)) {
    init = state.dashboardUser;

    var userInt = [];
    _.map(state.dashboardUser.userinterests_by_appuserid, (item, index) => {
      userInt.push(item.interestid);
    });
    init.userinterests = userInt;

    // User category split for primary  and other category
    var categoryArray = _.split(state.dashboardUser.usercategory, ",");
    var primary = categoryArray.shift();

    init.primarycategory = primary;
    init.othercategory = categoryArray.join(",");

    // User status related section
    var useractive = state.dashboardUser.isactive;
    var userwaitlist = state.dashboardUser.userwaitlistmode;

    if (useractive == 1 && userwaitlist == 0) {
      init.userstatus = "confirmed";
    } else if (
      (useractive == 1 && userwaitlist == 1) ||
      (useractive == 0 && userwaitlist == 1) // Here this extra check is done for old user or in any case a use having this status, then mark that user as waitlist
    ) {
      init.userstatus = "waitlist";
    } else if (useractive == 0 && userwaitlist == 0) {
      init.userstatus = "inactive";
    } else {
      init.userstatus = "confirmed";
    }
  }

  var templateData = null;

  if (
    state.templateData &&
    state.templateData.resource &&
    state.templateData.resource.length > 0
  ) {
    templateData = state.templateData.resource[0];
  }

  return {
    session: state.session,
    showModal: state.showDashboardUserModal,
    initialValues: init,
    editMode: !_.isEmpty(state.dashboardUser),
    eventDetails: state.userEventDetails,
    settingData: state.SettingData.resource,
    actionAppModules: state.actionAppModules,
    ticketList: state.allTicketList.resource,
    userCategoryList: state.userCategoryList,
    allSpeakers: state.allSpeakers,
    allSponsors: state.allSponsors,
    allExhibitors: state.allExhibitors,
    availableFeatures: state.availableFeatures,
    interestList: state.interests,
    templateData,
    passcodeEmail: state.passcodeEmail,
    badgeList: state.dashboardAllBadgeList,

    // Fields values props
    primarycategory: selector(state, "primarycategory"),
    othercategory: selector(state, "othercategory"),
    userstatus: selector(state, "userstatus"),
  };
}

function validate(values, props) {
  var { userCategoryList } = props;
  var errors = {};
  // var username = values['username'];
  var firstname = values["firstname"];
  var lastname = values["lastname"];
  var email = values["email"];
  var primarycategory = values["primarycategory"];
  var othercategory = values["othercategory"];
  var userPassword = values["userpassword"];
  var maxLengthFields = ["firstname", "lastname", "groupname"];
  var facebook = values["facebook"];
  var twitter = values["twitter"];
  var linkedin = values["linkedin"];

  if (!firstname || firstname.trim() === "") {
    errors["firstname"] = LocaleStrings.user_validation_required;
  }
  if (!lastname || lastname.trim() === "") {
    errors["lastname"] = LocaleStrings.user_validation_required;
  }
  if (!email || email.trim() === "") {
    errors["email"] = LocaleStrings.user_validation_required;
  }
  if (email && !validateEmail(email)) {
    errors["email"] = LocaleStrings.user_validation_invalid_email;
  }
  if (!primarycategory || primarycategory.trim() === "") {
    errors["primarycategory"] = LocaleStrings.user_validation_required;
  }

  var categories = "";
  if (
    othercategory &&
    othercategory != "" &&
    Array.isArray(othercategory) &&
    othercategory.length > 0
  ) {
    let tags = _.map(othercategory, (el) => el.value);
    categories = tags.join(",");
  } else if (
    othercategory &&
    othercategory != "" &&
    !Array.isArray(othercategory)
  ) {
    if (typeof othercategory === "object") {
      categories = othercategory.value;
    } else {
      categories = othercategory;
    }
  }
  categories = primarycategory + "," + categories; // Adding primary key in 1st position.

  var adminDetails = _.filter(userCategoryList.data, (obj) => {
    return obj.type == "admin";
  });

  var isAdmin =
    adminDetails.length > 0
      ? categories.search(adminDetails[0]?.id.toString())
      : -1;

  if (isAdmin >= 0 && userPassword && userPassword.length < 6) {
    errors["userpassword"] = LocaleStrings.user_password_length_validation;
  }

  /*** Max Length Validation ***/
  maxLengthFields.forEach((field) => {
    if (values[field] && MAXLENOBJ) {
      if (values[field].length > MAXLENOBJ[field]) {
        errors[field] = LocaleStrings.max_characters_left + MAXLENOBJ[field];
      }
    }
  });

  if (twitter && !validateSocialMediaUrl(twitter)) {
    errors.twitter = LocaleStrings.user_validation_invalid_twitter_link;
    errors.display_othertab_error =
      LocaleStrings.user_validation_invalid_twitter_link;
  }
  if (linkedin && !validateSocialMediaUrl(linkedin)) {
    errors.linkedin = LocaleStrings.user_validation_invalid_linkedin_link;
    errors.display_othertab_error =
      LocaleStrings.user_validation_invalid_linkedin_link;
  }
  if (facebook && !validateSocialMediaUrl(facebook)) {
    errors.facebook = LocaleStrings.user_validation_invalid_facebook_link;
    errors.display_othertab_error =
      LocaleStrings.user_validation_invalid_facebook_link;
  }

  return errors;
}

export default connect(mapStateToProps, {
  openDashboardUserModal,
  addAppUser,
  editDashboardUser,
  updateUser,
  validateEmailForAppUser,
  validateEmailFromSystemDB,
  checkemailinSytemDB,
  showError,
  showSuccess,
  openUserCategoryModal,
  sendWelcomeMail,
  fetchPasscode,
  deleteDashboardUser,
  uploadUserattachments,
  sendShortlistedEmail,
  insertSpeaker,
  fetchAllSpeakers,
  fetchAllBadgeList,
  generateBadges,
  getScannedItems,
})(
  reduxForm({
    validate,
    form: "DashboardAddUserForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(AddUserDialog)
);

class AddUserForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      imagePreviewUrl: "",
      coverImagePreviewUrl: "",
      showPasswordField: false,
      showCreateSpeakerField: false,
      userInterest: [],
      passcodeOpen: false,
      copied: false,
    };
    this.deleteUser = this.deleteUser.bind(this);
  }

  componentDidMount() {
    MAXLENOBJ = MaxCharacterObject.dashboard.tickets.appusers; // filter This form name object With route
    var { editMode, initialValues, session, userCategoryList } = this.props;

    if (editMode) {
      var adminDetails = _.filter(userCategoryList.data, (obj) => {
        return obj.type == "admin";
      });
      var isAdmin =
        adminDetails.length > 0 && initialValues.usercategory
          ? initialValues.usercategory.search(adminDetails[0].id)
          : -1;

      if (
        initialValues &&
        isAdmin >= 0 &&
        initialValues.isadmin &&
        session.userid != initialValues.appuserid
      ) {
        this.setState({ showPasswordField: true });
      }
      this.setState({ userInterest: initialValues.userinterests });
    }

    document.addEventListener("click", this.handleOutsideClick, true);
    // return function to be called when unmounted
    return () => {
      document.removeEventListener("click", this.handleOutsideClick, true);
    };
  }

  copyUrl = () => {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
      this.props.showSuccess("Copied Successfully");
    }, 500);
  };

  onImageSave = (img) => {
    this.setState({ imagePreviewUrl: img == "" ? "removed" : img });
    this.props.autofill("profileimagehidden", img == "" ? "removed" : img);
  };

  onImageChange = (imageAvailable) => {};

  onCoverImageSave = (img) => {
    this.setState({ coverImagePreviewUrl: img == "" ? "removed" : img });
    this.props.autofill("coverimagehidden", img == "" ? "removed" : img);
  };

  onCoverImageChange = (imageAvailable) => {};

  handlePrimaryCategoryChange = (e) => {
    let { userCategoryList, othercategory, editMode } = this.props;
    let primarySelectValue = e.target.value;
    // console.log("othercategory :- ", othercategory);

    var categories = [];
    if (
      othercategory &&
      othercategory != "" &&
      Array.isArray(othercategory) &&
      othercategory.length > 0
    ) {
      let tags = _.map(othercategory, (el) => el.value);
      categories = tags;
    } else if (
      othercategory &&
      othercategory != "" &&
      !Array.isArray(othercategory)
    ) {
      categories = _.split(othercategory, ",");
    }

    var othersCategorysNew = _.filter(categories, (obj) => {
      return obj != primarySelectValue;
    });
    // console.log("othersCategorysNew :- ", othersCategorysNew);

    var othercategories = [];
    othersCategorysNew.forEach((item, index) => {
      var checkinallcat = _.filter(userCategoryList.data, (obj) => {
        return obj.id == item;
      });
      if (checkinallcat.length > 0) {
        var obj = {
          label: checkinallcat[0].groupname,
          name: checkinallcat[0].groupname,
          value: checkinallcat[0].id.toString(),
        };

        // Others user group options
        othercategories.push(obj);
      }
    });
    // console.log("othercategories :- ", othercategories);

    this.props.autofill("othercategory", othercategories);

    // Primary field checking
    var checkPrimary = _.filter(userCategoryList.data, (obj) => {
      return obj.id == primarySelectValue;
    });

    // Other field checking
    var adminCatDetails = _.filter(userCategoryList.data, (obj) => {
      return obj.type == "admin";
    });

    // This section is used for admin password field visibility
    var checkOtherCategory = _.filter(othercategories, (obj) => {
      return obj.value == adminCatDetails[0].id;
    });

    if (
      (checkPrimary.length > 0 && checkPrimary[0].type === "admin") ||
      checkOtherCategory.length
    ) {
      this.setState({ showPasswordField: true });
    } else {
      this.props.autofill("userpassword", null);
      this.props.untouch("userpassword");
      this.setState({ showPasswordField: false });
    }

    // This section is used for create sepaker too field visibility
    if (
      checkPrimary.length > 0 &&
      checkPrimary[0].type === "speaker" &&
      !editMode
    ) {
      this.setState({ showCreateSpeakerField: true });
      this.props.autofill("createspeaker", false);
    } else {
      this.setState({ showCreateSpeakerField: false });
      this.props.autofill("createspeaker", false);
    }
  };

  handleCategoryChange = (e) => {
    var { userCategoryList, primarycategory } = this.props;
    let tags = _.map(e, (el) => el.value).filter((item) => {
      return item != undefined;
    });
    var category = tags;

    // This section is used for admin password field visibility
    // Other field checking
    var adminDetails = _.filter(userCategoryList.data, (obj) => {
      return obj.type == "admin";
    });

    if (category.length > 0 && adminDetails.length > 0) {
      var isAdmin = _.filter(category, (obj) => {
        return obj == adminDetails[0].id;
      });

      // Primary field checking
      var isPrimaryAdmin = _.filter(userCategoryList.data, (obj) => {
        return obj.id == primarycategory;
      });

      if (
        isAdmin.length > 0 ||
        (isPrimaryAdmin.length > 0 && isPrimaryAdmin[0].type === "admin")
      ) {
        this.setState({ showPasswordField: true });
      } else {
        this.props.autofill("userpassword", null);
        this.props.untouch("userpassword");
        this.setState({ showPasswordField: false });
      }
    } else {
      this.props.autofill("userpassword", null);
      this.setState({ showPasswordField: false });
    }
  };

  handleUserStatus = (e) => {
    // var selected = e.target.value;

    this.props.autofill("sendwelcomeemail", false);
  };

  seePasscode = () => {
    this.setState({ passcodeOpen: true });
  };

  toggleCalendar = () => {
    this.setState({ passcodeOpen: false });
  };

  // Old code
  //handleOutsideClick = (e) => {
  //   console.log("222", e);
  //   console.log("e.target", e.target);
  //   if (!this.node.contains(e.target)) this.toggleCalendar();
  // };

  /* New code */
  handleOutsideClick(e) {
    if (this.pop) {
      const domNode = ReactDOM.findDOMNode(this.pop);
      if (!this.pop.contains(e.target)) {
        //
        this.toggleCalendar();
      }
    }
  }

  sendMail = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    var email = this.props.initialValues.email;

    this.props.sendWelcomeMail(
      this.props.session,
      { email: email },
      (response) => {
        this.setState({ loading: false });
        if (response.success === 1) {
          this.props.showSuccess(LocaleStrings.user_message_welcome_email_sent);
        } else if (response.success === 3) {
          this.props.showSuccess(
            LocaleStrings.user_message_welcome_email_error1
          );
        } else if (response.success === 4) {
          this.props.showSuccess(
            LocaleStrings.user_message_welcome_email_error2
          );
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  sendShortlistedMail = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    var email = this.props.initialValues.email;

    this.props.sendShortlistedEmail(
      this.props.session,
      this.props.templateData,
      { email: email },
      (response) => {
        if (response.success === 1) {
          this.props.showSuccess("Shortlisted Mail Sent Successfully");
          this.setState({ loading: false });
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
          this.setState({ loading: false });
        }
      }
    );
  };

  deleteUser() {
    let pageNo = this.props.currentPage;
    if (this.props.pageDataLength == 1) {
      pageNo = pageNo - 1;
    }

    confirmAlert({
      title: LocaleStrings.user_title_delete_users,
      message: LocaleStrings.user_text_permanently_delete_user,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteDashboardUser(
              this.props.session,
              this.props.initialValues,
              (response) => {
                if (response.success === 0) {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  let user = this.props.initialValues;
                  user.deleted = true;
                  this.props.showSuccess(
                    LocaleStrings.user_message_user_deleted
                  );
                  this.props.closeModals();
                  this.props.checkAndUncheckUsers(user);
                  this.props.pagination(pageNo);
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  renderCustomAutoComplete(field) {
    // new customizaton added by udayan(06/09/22)
    let allinputval = field.input.value;
    let SelectedArrtObj = [];
    if (
      typeof allinputval === "string" &&
      allinputval !== "" &&
      _.size(field.options) > 0
    ) {
      var nameArr = allinputval.split(",");

      _.forEach(nameArr, function (values) {
        let obj = {};
        let filterValues = _.filter(field.options, {
          value: values,
        });
        if (filterValues && filterValues.length > 0) {
          obj.label = filterValues[0].label;
          obj.name = filterValues[0].name;
          obj.value = filterValues[0].value;
        }
        SelectedArrtObj.push(obj);
      });
      if (_.size(SelectedArrtObj) > 0) {
        field.input.value = SelectedArrtObj;
      }
    }

    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass}`;

    return (
      <div className={divClassName}>
        <label className="control-label-top col-sm-12">
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
          <OverlayTrigger
            key={`category`}
            placement="right"
            overlay={
              <Tooltip id={`tooltip-category`} style={{ marginTop: "-5px" }}>
                <div className="custom-text1-white-normal">
                  {LocaleStrings.user_form_text_category_info}
                </div>
              </Tooltip>
            }
          >
            <img
              src="../../style/images/header-icons/infoicon.png"
              className="ml-10 pointer"
              alt="info icon"
            />
          </OverlayTrigger>
        </label>
        {/* <div className="col-sm-12 col-sm-offset-0"> */}
        <div
          className={`col-md-12 col-sm-12 col-sm-offset-0 ${
            DEVELOPMENT_TYPE === "koachify"
              ? ""
              : "d-flex wrapper-custom-addUser-basicDetails-category"
          }`}
        >
          <Select
            className={`react-multi-select-custom-css ${
              field.input.value ? "has-value" : ""
            }`}
            {...field.input}
            isMulti={field.isMulti ? true : false}
            value={field.input.value || ""}
            valueKey={field.valueKey}
            placeholder={field.placeholder}
            labelKey={field.labelKey}
            options={field.options}
            // onBlur={() => field.input.onBlur(field.input.value)}
            isClearable
            onBlur={(event) => {
              event.preventDefault();
            }}
          />
          {DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            <Button
              className="btn btn-custom-blue ml-10"
              onClick={field.onManageClick}
            >
              {LocaleStrings.button_manage_category}
            </Button>
          )}
        </div>
        <div className="col-md-12 col-sm-12 col-sm-offset-0 text-help label-text-help">
          {field.meta.touched ? field.meta.error : ""}
        </div>
      </div>
    );
  }

  handleUserInterest = (item) => {
    var array = this.state.userInterest;

    if (_.includes(array, item.interestid)) {
      var filter = _.filter(array, function (n) {
        return n != item.interestid;
      });
      array = filter;
    } else {
      array = [...array, item.interestid];
    }

    this.setState({ userInterest: array });
    this.props.autofill(`userinterests`, array);
  };

  _renderInterests = () => {
    let { interestList } = this.props;
    let { userInterest } = this.state;

    return _.map(interestList, (item, index) => {
      return (
        <div
          key={`int_key${index}`}
          className={`custom-text1-primary-normal ${
            _.includes(userInterest, item.interestid)
              ? "selected-interest"
              : "interests"
          }`}
          onClick={() => this.handleUserInterest(item)}
        >
          {item.interest}
          {_.includes(userInterest, item.interestid) ? (
            <span>
              &nbsp; <i className="fa fa-check" aria-hidden="true"></i>
            </span>
          ) : (
            ""
          )}
        </div>
      );
    });
  };

  render() {
    var {
      editMode,
      initialValues,
      session,
      userCategoryList,
      settingData,
      primarycategory,
      userstatus,
    } = this.props;
    var {
      imagePreviewUrl,
      coverImagePreviewUrl,
      showPasswordField,
      showCreateSpeakerField,
      passcodeOpen,
    } = this.state;
    var userStatusList = [
      {
        text: LocaleStrings.user_form_label_user_status_option1,
        value: "confirmed",
      },
      {
        text: LocaleStrings.user_form_label_user_status_option2,
        value: "waitlist",
      },
      {
        text: LocaleStrings.user_form_label_user_status_option3,
        value: "inactive",
      },
    ];

    var categories = [];
    var othercategories = [];
    if (
      userCategoryList &&
      userCategoryList.data &&
      userCategoryList.data.length > 0
    ) {
      userCategoryList.data.forEach((item, index) => {
        var obj = {
          label: item.groupname,
          name: item.groupname,
          value: item.id.toString(),
        };
        categories.push(obj);

        // Others user group options
        if (item.id != primarycategory) {
          othercategories.push(obj);
        }
      });
    }

    // console.log("categories :- ", categories);
    // console.log("primarycategory :- ", primarycategory);
    // console.log("othercategories :- ", othercategories);

    var createdon = this.props.editMode
      ? converDateIntoLocal(this.props.initialValues.createdon)
      : "";

    var createdby = LocaleStrings.user_form_label_added_by_option1;
    if (this.props.initialValues.comesfrom === "ticket") {
      createdby = LocaleStrings.user_form_label_added_by_option2;
    } else if (this.props.initialValues.comesfrom === "open_registration") {
      createdby = LocaleStrings.user_form_label_added_by_option3;
    } else if (this.props.initialValues.comesfrom === "proposal") {
      createdby = LocaleStrings.user_form_label_added_by_option4;
    } else if (this.props.initialValues.comesfrom === "api") {
      createdby = LocaleStrings.user_form_label_added_by_option5;
    }

    var adminCategories = [];
    if (
      editMode &&
      initialValues.isadmin == 1 &&
      session.userid == initialValues.appuserid
    ) {
      var adminCategory = initialValues.usercategory;
      var adminCategoryArr = adminCategory.split(",");

      _.map(adminCategoryArr, (item, index) => {
        var categoryDetails = _.filter(userCategoryList.data, (obj) => {
          return obj.id == item;
        });

        if (categoryDetails.length > 0) {
          adminCategories.push(categoryDetails[0].groupname);
        }
      });
    }

    let tempImage = "";
    let profileCoverTempImage = "";
    if (editMode && initialValues.profileurl) {
      tempImage = `${BASE_IMAGES_URL}/${initialValues.profileurl}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
    }
    if (imagePreviewUrl == "") {
      imagePreviewUrl = tempImage;
    } else if (imagePreviewUrl == "removed") {
      imagePreviewUrl = "";
    }

    if (editMode && initialValues.coverimage) {
      profileCoverTempImage = `${BASE_IMAGES_URL}/${initialValues.coverimage}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
    }
    if (coverImagePreviewUrl == "") {
      coverImagePreviewUrl = profileCoverTempImage;
    } else if (coverImagePreviewUrl == "removed") {
      coverImagePreviewUrl = "";
    }

    // console.log("initialValues", initialValues);
    // console.log("settingData", settingData);

    return (
      <div className="basicform">
        <div className="form-group">
          {editMode ? (
            <div className="row">
              <div
                className="col-md-4"
                style={{ display: "block", paddingLeft: 0 }}
              >
                {passcodeOpen == false ? (
                  <>
                    <label
                      className="control-label-top"
                      style={{ paddingBottom: 5 }}
                    >
                      {LocaleStrings.user_form_label_passcode}
                    </label>
                    <div style={{ paddingBottom: 5 }}>
                      <Button
                        className="btn btn-custom-table-blue"
                        // loading={this.state.loading}
                        type="button"
                        onClick={
                          initialValues.isactive == 1 &&
                          initialValues.userwaitlistmode == 0
                            ? this.seePasscode
                            : null
                        }
                        disabled={
                          initialValues.isactive == 1 &&
                          initialValues.userwaitlistmode == 0
                            ? false
                            : true
                        }
                      >
                        <img
                          className="i-custom-table"
                          style={{
                            height: "20px",
                            width: "20px",
                            marginRight: "10px",
                          }}
                          src="../../style/images/custom-icons/passcode.svg"
                          alt="passcode"
                        />
                        {LocaleStrings.user_form_text_see_passcode}
                      </Button>
                    </div>
                  </>
                ) : (
                  <>
                    <label
                      className="control-label-top"
                      style={{ paddingBottom: 5 }}
                    >
                      {LocaleStrings.user_form_label_passcode}
                    </label>
                    <div style={{ paddingBottom: 5 }}>
                      {this.props.passcodeEmail == undefined ? (
                        <div
                          ref={(node) => {
                            this.node = node;
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-custom-white"
                          >
                            {LocaleStrings.user_form_text_no_passcode}
                          </button>
                        </div>
                      ) : (
                        <div
                          ref={(node) => {
                            this.node = node;
                          }}
                          style={{ display: "flex" }}
                        >
                          <button
                            type="button"
                            className="btn btn-custom-white"
                            style={{ marginRight: "5px" }}
                          >
                            {this.props.passcodeEmail.handshakecode}
                          </button>

                          <CopyToClipboard
                            text={this.props.passcodeEmail.handshakecode}
                            onCopy={this.copyUrl}
                          >
                            {this.state.copied ? (
                              <a className="btn btn-custom-blue btn-v-center">
                                <i
                                  className="fa fa-files-o i-custom-m"
                                  aria-hidden="true"
                                ></i>
                              </a>
                            ) : (
                              <a className="btn btn-custom-blue btn-v-center">
                                <i
                                  className="fa fa-files-o i-custom-m"
                                  aria-hidden="true"
                                ></i>
                              </a>
                            )}
                          </CopyToClipboard>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>

              <div
                className="col-md-5- col-md-6 px-0"
                style={{
                  marginTop: "36px",
                  textAlign: "start",
                }}
              >
                <div style={{ paddingBottom: 5, textAlign: "start" }}>
                  {initialValues.hasOwnProperty("commingFrom") &&
                  initialValues.commingFrom == "proposal_shortlisted" ? (
                    <Button
                      className="btn btn-custom-table-blue"
                      loading={this.state.loading}
                      type="button"
                      onClick={
                        initialValues.isactive == 1
                          ? this.sendShortlistedMail
                          : null
                      }
                      disabled={initialValues.isactive == 1 ? false : true}
                    >
                      <img
                        className="i-custom-table"
                        style={{
                          height: "20px",
                          width: "20px",
                          marginRight: "10px",
                        }}
                        src="../../style/images/custom-icons/mail.svg"
                        alt="mail"
                      />
                      {LocaleStrings.button_send_shortlist_email}
                    </Button>
                  ) : (
                    <Button
                      className="btn btn-custom-table-blue"
                      loading={this.state.loading}
                      type="button"
                      onClick={
                        initialValues.isactive == 1 ? this.sendMail : null
                      }
                      disabled={initialValues.isactive == 1 ? false : true}
                    >
                      <img
                        className="i-custom-table"
                        style={{
                          height: "20px",
                          width: this.state.loading ? "12px" : "20px",
                          marginRight: "10px",
                        }}
                        src="../../style/images/custom-icons/mail.svg"
                        alt="mail"
                      />
                      {LocaleStrings.button_send_welcome_email}
                    </Button>
                  )}
                </div>
              </div>

              {editMode &&
              initialValues.isadmin &&
              session.userid == initialValues.appuserid ? null : (
                <div
                  className="col-md-3- col-md-2 px-0"
                  style={{ marginTop: "36px", marginLeft: "-20px" }}
                >
                  <div style={{ textAlign: "end" }}>
                    <Button
                      className="deltenew"
                      style={{ display: "flex" }}
                      type="button"
                      onClick={this.deleteUser}
                    >
                      <img
                        className="i-custom-table"
                        style={{
                          height: "20px",
                          width: "20px",
                          marginRight: "10px",
                        }}
                        src="../../style/images/custom-icons/newdelete.svg"
                        alt="delete"
                      />
                      <div style={{ paddingTop: "3px" }}>
                        {LocaleStrings.button_delete}
                      </div>
                    </Button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            ""
          )}

          {/* new profile coved image ui hide as it will go in next production phase */}

          {/* <div className="Row">
            <div style={{ padding: 0, position: "relative" }}>
              <label className="control-label-top">
                {LocaleStrings.user_form_label_profile_cover}
              </label>
              <ImageCropper
                displaySize={{ width: 500, height: 250 }} // For image display style
                requiredSize={{ width: 700, height: 366 }} // For image size required validation
                cropperSize={{ width: 500, height: 200 }} // Cropper display size. Note its add 50px for padding
                border={10}
                onImageSave={this.onCoverImageSave}
                onImageChange={this.onCoverImageChange}
                imagepath={coverImagePreviewUrl}
                imageType="jpg"
                className="drop-zone-area-custom-image"
                insideImage="../../style/images/dummy-image-fill@3x.png"
                insideImageStyle={{
                  width: 200,
                  height: 50,
                }}
                insideText="Drag and Drop or Click here to upload image. Image size must be 700x366 px."
              />
              <Field
                name="coverimagehidden"
                type="text"
                component={this.renderHiddenFieldText}
              />
            </div>
          </div>
          <div className="row">
            <div
              style={{
                padding: 0,
                position: "relative",
                marginTop: -120,
                marginLeft: 30,
              }}
            >
              <label className="control-label-top"></label>
              <ImageCropper
                displaySize={{ width: 200, height: 231 }} // For image display style
                requiredSize={{ width: 200, height: 200 }} // For image size required validation
                cropperSize={{ width: 120, height: 120 }} // Cropper display size. Note its add 50px for padding
                border={10}
                onImageSave={this.onImageSave}
                onImageChange={this.onImageChange}
                imagepath={imagePreviewUrl}
                imageType="jpg"
                className="drop-zone-area-custom-image"
                insideImage="../../style/images/dummy-image-fill@3x.png"
                insideImageStyle={{
                  width: 36,
                  height: 36,
                }}
                insideText="Drag and Drop or Click here to upload image. Image size must be 200x200 px."
              />
              <Field
                name="profileimagehidden"
                type="text"
                component={this.renderHiddenFieldText}
              />
            </div>
          </div>
          <div className="row">
            <div>
              {editMode &&
              initialValues.isadmin &&
              session.userid == initialValues.appuserid ? (
                <div className="form-group row">
                  <label className="control-label-top col-sm-12">
                    {LocaleStrings.user_form_label_email}
                    <span className="label-mandatory">*</span>
                  </label>
                  <div
                    className="col-sm-12 col-sm-offset-0"
                    style={{
                      fontWeight: "700",
                      color: "#2676ea",
                    }}
                  >
                    {this.props.initialValues.email}
                  </div>
                </div>
              ) : (
                <Field
                  name="email"
                  label={LocaleStrings.user_form_label_email}
                  placeholder={LocaleStrings.user_form_label_email}
                  type="email"
                  component={this.renderFieldText}
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                />
              )}
              <div className="d-flex justify-content-between">
                <div className="mr-5">
                  <Field
                    name="firstname"
                    label={LocaleStrings.user_form_label_firstname}
                    placeholder={LocaleStrings.user_form_label_firstname}
                    type="text"
                    component={this.renderFieldText}
                    mandatory="true"
                    labelposition={LABEL_POSITION_TOP}
                    maxlength={MAXLENOBJ.firstname ? MAXLENOBJ.firstname : ""}
                  />
                </div>
                <div>
                  {" "}
                  <Field
                    name="lastname"
                    label={LocaleStrings.user_form_label_lastname}
                    placeholder={LocaleStrings.user_form_label_lastname}
                    type="text"
                    component={this.renderFieldText}
                    mandatory="true"
                    labelposition={LABEL_POSITION_TOP}
                    maxlength={MAXLENOBJ.lastname ? MAXLENOBJ.lastname : ""}
                  />
                </div>
              </div>
            </div>
          </div> */}

          <div className="row">
            <div
              className="col-md-4"
              style={{ padding: 0, position: "relative" }}
            >
              <label className="control-label-top">
                {LocaleStrings.user_form_label_profile}
              </label>
              <ImageCropper
                displaySize={{ width: 200, height: 231 }} // For image display style
                requiredSize={{ width: 200, height: 200 }} // For image size required validation
                cropperSize={{ width: 120, height: 120 }} // Cropper display size. Note its add 50px for padding
                border={10}
                onImageSave={this.onImageSave}
                onImageChange={this.onImageChange}
                imagepath={imagePreviewUrl}
                imageType="jpg"
                className="drop-zone-area-custom-image"
                insideImage="../../style/images/dummy-image-fill@3x.png"
                insideImageStyle={{
                  width: 36,
                  height: 36,
                }}
                insideText="Drag and Drop or Click here to upload image. Image size must be 200x200 px."
              />
              <Field
                name="profileimagehidden"
                type="text"
                component={this.renderHiddenFieldText}
              />
            </div>
            <div
              className="col-md-8"
              style={{ paddingLeft: "45px", paddingRight: 0 }}
            >
              {editMode &&
              initialValues.isadmin &&
              session.userid == initialValues.appuserid ? (
                <div className="form-group row">
                  <label className="control-label-top col-sm-12">
                    {LocaleStrings.user_form_label_email}
                    <span className="label-mandatory">*</span>
                  </label>
                  <div
                    className="col-sm-12 col-sm-offset-0"
                    style={{
                      fontWeight: "700",
                      color: "#2676ea",
                    }}
                  >
                    {this.props.initialValues.email}
                  </div>
                </div>
              ) : (
                <Field
                  name="email"
                  label={LocaleStrings.user_form_label_email}
                  placeholder={LocaleStrings.user_form_label_email}
                  type="email"
                  component={this.renderFieldText}
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                />
              )}
              <Field
                name="firstname"
                label={LocaleStrings.user_form_label_firstname}
                placeholder={LocaleStrings.user_form_label_firstname}
                type="text"
                component={this.renderFieldText}
                mandatory="true"
                labelposition={LABEL_POSITION_TOP}
                maxlength={MAXLENOBJ.firstname ? MAXLENOBJ.firstname : ""}
              />
              <Field
                name="lastname"
                label={LocaleStrings.user_form_label_lastname}
                placeholder={LocaleStrings.user_form_label_lastname}
                type="text"
                component={this.renderFieldText}
                mandatory="true"
                labelposition={LABEL_POSITION_TOP}
                maxlength={MAXLENOBJ.lastname ? MAXLENOBJ.lastname : ""}
              />
            </div>
          </div>
        </div>

        {editMode &&
        initialValues.isadmin &&
        session.userid == initialValues.appuserid ? (
          <div className="form-group row">
            <label className="control-label-top col-sm-12">
              {LocaleStrings.user_form_label_category}
            </label>
            <div
              className="col-sm-9 col-sm-offset-0"
              style={{
                padding: "6px 14px",
                fontWeight: "bold",
                color: "#4da1ff",
                textTransform: "uppercase",
              }}
            >
              {adminCategories.join(", ")}
            </div>
          </div>
        ) : (
          <>
            <Field
              name="primarycategory"
              label={LocaleStrings.user_form_label_primary_category}
              placeholder={LocaleStrings.user_form_label_ph_primary_category}
              component={this.renderSelect}
              mandatory="true"
              opts={categories}
              onChange={this.handlePrimaryCategoryChange}
              labelposition={LABEL_POSITION_TOP}
            />
            <Field
              name="othercategory"
              label={LocaleStrings.user_form_label_other_category}
              placeholder={LocaleStrings.user_form_label_ph_other_category}
              component={this.renderCustomAutoComplete}
              mandatory="false"
              isMulti={true}
              options={othercategories}
              labelKey="label"
              valueKey="value"
              onChange={this.handleCategoryChange}
              onManageClick={this.props.onManageCategory}
            />
          </>
        )}
        {DEVELOPMENT_TYPE === "koachify" &&
        session.userid != initialValues.appuserid ? (
          <Field
            name="userpassword"
            label={LocaleStrings.user_form_label_password}
            placeholder={LocaleStrings.user_form_label_password_placeholder}
            type="password"
            component={this.renderFieldText}
            labelposition={LABEL_POSITION_TOP}
          />
        ) : (
          <div>
            {showPasswordField == true ? (
              <Field
                name="userpassword"
                label={LocaleStrings.user_form_label_password}
                placeholder={LocaleStrings.user_form_label_password_placeholder}
                type="password"
                component={this.renderFieldText}
                labelposition={LABEL_POSITION_TOP}
              />
            ) : null}
          </div>
        )}

        <div className="row form-group">
          <div className="col-sm-12">
            <label className="control-label-top">
              {LocaleStrings.user_form_label_interest}
            </label>

            <div className="interest-section">{this._renderInterests()}</div>
            <Field
              name="userinterests"
              type="text"
              component={this.renderHiddenFieldText}
            />
          </div>
        </div>
        {editMode ? (
          <div>
            <div className="row form-group">
              <label className="control-label-top col-sm-3">
                {LocaleStrings.user_form_label_added_by}
              </label>
              <div
                className="col-sm-12"
                style={{ fontWeight: "bold", color: "#2676ea" }}
              >
                {createdby}{" "}
                <span style={{ fontSize: 10, fontWeight: 400 }}>
                  ( {createdon} )
                </span>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {editMode &&
        (initialValues.appuserid == session.userid ||
          initialValues.issuperadmin) ? (
          ""
        ) : (
          <div className="row form-group">
            <label className="control-label-top col-sm-12">
              {LocaleStrings.user_form_label_user_status}
            </label>
            <div className="col-sm-12 d-flex-wrap">
              {_.map(userStatusList, (opt, index) => {
                return (
                  <Field
                    key={`userstatus_key_${index}`}
                    name="userstatus"
                    label={opt.text}
                    value={opt.value}
                    type="radio"
                    component={this.renderFieldRadio}
                    onChange={(e) => this.handleUserStatus(e)}
                  />
                );
              })}
            </div>
          </div>
        )}

        {userstatus !== "inactive" && !initialValues.issuperadmin ? (
          <div className="row form-group">
            <div className="col-sm-12">
              <Field
                name="sendwelcomeemail"
                label={LocaleStrings.user_form_label_send_email}
                type="checkbox"
                component={this.renderFieldCheckbox}
              />
            </div>
          </div>
        ) : (
          ""
        )}

        {!editMode && showCreateSpeakerField ? (
          <div className="row form-group">
            <div className="col-sm-12">
              <Field
                name="createspeaker"
                label={LocaleStrings.user_form_label_create_speaker}
                type="checkbox"
                component={this.renderFieldCheckbox}
              />
            </div>
          </div>
        ) : (
          ""
        )}

        {editMode && initialValues.playerid ? (
          <div className="row form-group">
            <div className="col-sm-12">
              <i
                className="fa fa-check text-custom-success"
                aria-hidden="true"
                style={{ fontSize: 18 }}
              ></i>

              <span className="custom-text1-primary-normal ml-5">
                {LocaleStrings.user_form_text_user_push_subscribed}
              </span>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

class ContactForm extends BaseComponent {
  constructor(props) {
    super(props);
  }

  changeRating = (newRating, name) => {
    var eventForm =
      this.props.settingData &&
      this.props.settingData.length > 0 &&
      this.props.settingData[0].event_forms_by_eventformid
        ? JSON.parse(
            this.props.settingData[0].event_forms_by_eventformid.formjson
          )
        : [];

    _.map(eventForm, (form, index) => {
      var name = form.name;
      if (form.key == "rating") {
        this.props.autofill(name, newRating);
      }
    });
  };

  renderRating(field) {
    var { input } = field;
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass}`;

    var labelClasses = "control-label-top col-sm-12";
    var inputClasses = "col-sm-12 col-sm-offset-0";

    return (
      <div className={divClassName}>
        <label className={labelClasses}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <div className={inputClasses}>
          <StarRatings
            {...input}
            rating={field.rating}
            starRatedColor="#FFD700"
            starHoverColor="#FFD700"
            starEmptyColor="#ABABAB"
            starDimension="25px"
            numberOfStars={5}
            name={field.name}
            changeRating={input.onChange}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderOtherFormSelect(field) {
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    return (
      <div className={divClassName}>
        <label className="control-label-top col-sm-12">
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <div className="col-sm-12 col-sm-offset-0">
          <select
            className="form-control dropdown-height-border"
            {...field.input}
          >
            <option value="" key={field.label}>
              {field.placeholder}
            </option>
            {field.opts.map((object, index) => {
              return (
                <option key={`${object.value}-${index}`} value={object.value}>
                  {object.text}
                </option>
              );
            })}
          </select>
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderCheckbox(field) {
    let { label, required, opts, input, meta } = field;
    var divClassName = `form-group row ${
      meta.touched && meta.error ? "has-danger" : ""
    }`;
    return (
      <div className={divClassName}>
        <label className="control-label-top col-sm-12">
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <div className="col-sm-12 col-sm-offset-0">
          {opts.map((option, index) => {
            return (
              <div key={index}>
                <label
                  className="custom-container-checkbox"
                  style={{ marginBottom: 5 }}
                >
                  {option.text}
                  {/* {option.value} */}
                  <input
                    type="checkbox"
                    name={`${input.name}[${index}]`}
                    value={option.value}
                    checked={input.value.indexOf(option.value) !== -1}
                    onChange={(event) => {
                      const newValue = [...input.value];
                      if (event.target.checked) {
                        newValue.push(option.value);
                      } else {
                        newValue.splice(newValue.indexOf(option.value), 1);
                      }
                      return input.onChange(newValue);
                    }}
                  />
                  <span className="checkmark" />
                </label>

                {/* <input type="checkbox"
                    name={`${input.name}[${index}]`}
                    value={option.value}
                    checked={input.value.indexOf(option.value) !== -1}
                    onChange={(event) => {
                      const newValue = [...input.value];
                      if (event.target.checked) {
                        newValue.push(option.value);
                      } else {
                        newValue.splice(newValue.indexOf(option.value), 1);
                      }
                      return input.onChange(newValue);
                    }}
                  />
                  <label style={{marginLeft: 5}}>{option.text}</label> */}
              </div>
            );
          })}
          <div className="text-help label-text-help">
            {meta.touched ? meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  render() {
    // let { fileArr } = this.state;
    var eventForm =
      this.props.settingData &&
      this.props.settingData.length > 0 &&
      this.props.settingData[0].event_forms_by_eventformid
        ? JSON.parse(
            this.props.settingData[0].event_forms_by_eventformid.formjson
          )
        : [];
    var savedForm =
      this.props.initialValues && this.props.initialValues.responses
        ? JSON.parse(this.props.initialValues.responses)
        : [];
    var rate = 0;

    if (this.props.editMode && this.props.initialValues.comesfrom == "ticket") {
      var matchedTicket = _.filter(this.props.ticketList, (ticket) => {
        return ticket.id == this.props.initialValues.ticketid;
      });

      if (matchedTicket.length > 0 && matchedTicket[0].event_forms_by_formid) {
        eventForm = JSON.parse(matchedTicket[0].event_forms_by_formid.formjson);
      }
    }

    if (savedForm && savedForm.length > 0) {
      _.map(eventForm, (form, index) => {
        // var name = form.label.replace(/ +/g, "");
        var name = form.name;
        var formKey = form.key;

        var check = [];
        if (name != "isnetworking") {
          check = _.filter(savedForm, function (saved) {
            return saved.name === name;
          });
        }
        if (
          check &&
          check.length > 0 &&
          check[0].value &&
          name == check[0].name
        ) {
          this.props.initialValues[check[0].name] = check[0].value;

          if (form.key == "rating" && name == check[0].name) {
            rate = check[0].value;
          }

          // Below if conditions are used to check if any key type changed, accordingly keeping value, so saved value will not lost

          // Checking if dropdown, radio saved value changed to input, number, textarea
          if (
            (formKey === "textinput" ||
              formKey === "numberinput" ||
              formKey == "textarea") &&
            (check[0].key === "dropdown" || check[0].key === "radiobuttons")
          ) {
            var options = check[0].options;
            var checkValue = _.filter(options, function (opt) {
              return (
                opt.text === check[0].value || opt.value === check[0].value
              );
            });

            if (checkValue && checkValue.length > 0) {
              this.props.initialValues[check[0].name] = checkValue[0].text;
            } else {
              this.props.initialValues[check[0].name] = "";
            }
          }

          // Checking if checkboxes saved value changed to input, number, textarea
          if (
            (formKey === "textinput" ||
              formKey === "numberinput" ||
              formKey == "textarea") &&
            check[0].key === "checkboxes"
          ) {
            var options = check[0].options;
            var checkBoxSavedValue = check[0].value;

            var displayValue = [];
            _.map(checkBoxSavedValue, (box, index) => {
              var checkValue = _.filter(options, function (opt) {
                return opt.text === box || opt.value === box;
              });

              if (checkValue && checkValue.length > 0) {
                displayValue.push(checkValue[0].text);
              }
            });

            if (displayValue.length > 0) {
              this.props.initialValues[check[0].name] = displayValue.join(",");
            } else {
              this.props.initialValues[check[0].name] = "";
            }
          }

          // Checking if input, number, textarea saved value changed to dropdown, radio
          if (
            (formKey === "dropdown" || formKey === "radiobuttons") &&
            (check[0].key === "textinput" ||
              check[0].key === "numberinput" ||
              check[0].key === "textarea")
          ) {
            var options = form.options;
            var checkValue = _.filter(options, function (opt) {
              return (
                opt.text === check[0].value || opt.value === check[0].value
              );
            });

            if (checkValue && checkValue.length > 0) {
              this.props.initialValues[name] = checkValue[0].value;
            } else {
              this.props.initialValues[name] = "";
            }
          }

          // Checking if input, number, textarea saved value changed to checkboxes
          if (
            formKey === "checkboxes" &&
            (check[0].key === "textinput" ||
              check[0].key === "numberinput" ||
              check[0].key === "textarea")
          ) {
            var options = form.options;
            var checkBoxSavedValue = check[0].value.split(",");
            var displayValue = [];
            _.map(checkBoxSavedValue, (box, index) => {
              var checkValue = _.filter(options, function (opt) {
                return opt.text === box || opt.value === box;
              });

              if (checkValue && checkValue.length > 0) {
                displayValue.push(checkValue[0].value);
              }
            });

            if (displayValue.length > 0) {
              this.props.initialValues[name] = displayValue;
            } else {
              this.props.initialValues[name] = "";
            }
          }

          // Checking if dropdown saved value changed to radiobuttons or vice versa
          if (
            (formKey === "dropdown" && check[0].key === "radiobuttons") ||
            (formKey === "radiobuttons" && check[0].key === "dropdown")
          ) {
            var options = check[0].options;
            var checkValue = _.filter(options, function (opt) {
              return (
                opt.text === check[0].value || opt.value === check[0].value
              );
            });

            if (checkValue && checkValue.length > 0) {
              this.props.initialValues[check[0].name] = checkValue[0].value;
            } else {
              this.props.initialValues[check[0].name] = "";
            }
          }

          // Checking if dropdown, radiobuttons saved value changed to checkboxes
          if (
            formKey === "checkboxes" &&
            (check[0].key === "dropdown" || check[0].key === "radiobuttons")
          ) {
            var options = form.options;
            var displayValue = [];
            var checkValue = _.filter(options, function (opt) {
              return (
                opt.text === check[0].value || opt.value === check[0].value
              );
            });
            if (checkValue && checkValue.length > 0) {
              displayValue.push(checkValue[0].value);
            }

            if (displayValue.length > 0) {
              this.props.initialValues[name] = displayValue;
            } else {
              this.props.initialValues[name] = "";
            }
          }

          // Checking if checkboxes saved value changed to dropdown, radiobuttons
          if (
            (formKey === "dropdown" || formKey === "radiobuttons") &&
            check[0].key === "checkboxes"
          ) {
            var options = form.options;

            var checkBoxSavedValue = check[0].value;

            var displayValue = "";
            var matched = false;
            for (let index = 0; index < checkBoxSavedValue.length; index++) {
              const box = checkBoxSavedValue[index];
              var checkValue = _.filter(options, function (opt) {
                return opt.text === box || opt.value === box;
              });

              if (checkValue && checkValue.length > 0) {
                matched = true;
                displayValue = checkValue[0].value;
                break;
              }
            }

            if (matched && displayValue != "") {
              this.props.initialValues[check[0].name] = displayValue;
            } else {
              this.props.initialValues[check[0].name] = "";
            }
          }
        }
      });
    }

    return (
      <div className="contactform">
        {_.map(eventForm, (form, index) => {
          // var name = form.label.replace(/ +/g, "");
          var name = form.name;

          return (
            <div key={index}>
              {form.key == "textinput" || form.key == "numberinput" ? (
                <Field
                  name={name}
                  label={form.label}
                  type={form.key == "textinput" ? "text" : "number"}
                  component={this.renderFieldText}
                  mandatory={false}
                  maxlength={form.maxlen}
                  labelposition={LABEL_POSITION_TOP}
                />
              ) : form.key == "textarea" ? (
                <Field
                  name={name}
                  label={form.label}
                  component={this.renderFieldTextarea}
                  mandatory={false}
                  maxlength={form.maxlen}
                  labelposition={LABEL_POSITION_TOP}
                />
              ) : form.key == "checkboxes" ? (
                <Field
                  name={name}
                  label={form.label}
                  type="checkbox"
                  component={this.renderCheckbox}
                  mandatory={false}
                  opts={form.options}
                />
              ) : form.key == "radiobuttons" ? (
                <div className="form-group row">
                  <label className="control-label-top col-sm-12">
                    {form.label}
                  </label>
                  <div className="col-sm-12 col-sm-offset-0">
                    {_.map(form.options, (opt, index) => {
                      return (
                        <div key={index} style={{ display: "flex" }}>
                          <Field
                            name={name}
                            label={opt.text}
                            value={opt.value}
                            type="radio"
                            // component="input"
                            component={this.renderFieldRadio}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : form.key == "dropdown" ? (
                <Field
                  name={name}
                  label={form.label}
                  placeholder="Select from options"
                  component={this.renderOtherFormSelect}
                  mandatory={false}
                  opts={form.options}
                />
              ) : form.key == "datepicker" ? (
                <Field
                  name={name}
                  label={form.label}
                  labelposition={LABEL_POSITION_TOP}
                  component={this.renderDatePicker}
                  mandatory={false}
                  // selected={format(new Date(), DATE_FORMAT_FNS)}
                />
              ) : form.key == "rating" ? (
                <div>
                  <Field
                    name={name}
                    label={form.label}
                    component={this.renderRating}
                    mandatory={false}
                    rating={rate}
                    onChange={this.changeRating}
                  />
                  <Field
                    name={name}
                    type="text"
                    component={this.renderHiddenFieldText}
                    bsClass="row"
                    formdiv="false"
                    labelposition={LABEL_POSITION_TOP}
                  />
                </div>
              ) : form.key == "hyperlink" ? (
                <div className="form-group row">
                  <label className="control-label-top col-sm-12">
                    {" "}
                    {form.label}{" "}
                  </label>
                  <a
                    href={form.link}
                    target="blank"
                    className="col-sm-12 col-sm-offset-0"
                    style={{
                      padding: "6px 14px",
                      fontWeight: "bold",
                      color: "#2676ea",
                    }}
                  >
                    {form.link}
                  </a>
                </div>
              ) : form.key == "label" ? (
                <label>{form.label}</label>
              ) : form.key == "paragraph" ? (
                <p>{form.label}</p>
              ) : form.key == "singlecheckbox" && name == "isnetworking" ? (
                <div className="form-group row">
                  <div className="col-sm-12 mt-15">
                    <Field
                      name={name}
                      label={form.label}
                      component={this.renderFieldCheckbox}
                      value="1"
                      type="checkbox"
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

class AddUserPermissionForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { speakerValue: {}, sponsorValue: {}, exhibitorValue: {} };
  }

  componentDidMount() {
    var { editMode, initialValues, allSpeakers, allSponsors, allExhibitors } =
      this.props;

    if (editMode) {
      var speakerDetails = _.filter(allSpeakers.data, (obj) => {
        return obj.speakerid == initialValues.speakeridfk;
      });
      var isSpeaker =
        speakerDetails.length > 0
          ? {
              name: `${speakerDetails[0].firstname} ${speakerDetails[0].lastname}`,
              speakerid: speakerDetails[0].speakerid.toString(),
            }
          : {};

      var sponsorDetails = _.filter(allSponsors.data, (obj) => {
        return obj.sponsorid == initialValues.sponsoridfk;
      });
      var isSponsor =
        sponsorDetails.length > 0
          ? {
              name: `${sponsorDetails[0].name}`,
              sponsorid: sponsorDetails[0].sponsorid.toString(),
            }
          : {};

      var exhibitorDetails = _.filter(allExhibitors.data, (obj) => {
        return obj.exhibitorid == initialValues.exhibitoridfk;
      });
      var isExhibitor =
        exhibitorDetails.length > 0
          ? {
              name: `${exhibitorDetails[0].name}`,
              exhibitorid: exhibitorDetails[0].exhibitorid.toString(),
            }
          : {};

      this.setState({
        speakerValue: isSpeaker,
        sponsorValue: isSponsor,
        exhibitorValue: isExhibitor,
      });
    }
  }

  render() {
    var { allSpeakers, allSponsors, allExhibitors, availableFeatures } =
      this.props;
    var { speakerValue, sponsorValue, exhibitorValue } = this.state;
    var speakerOptions = [];
    var sponsorOptions = [];
    var exhibitorOptions = [];

    if (allSpeakers && allSpeakers.data && allSpeakers.data.length > 0) {
      allSpeakers.data.forEach((item, index) => {
        var obj = {
          label: `${item.firstname} ${item.lastname}`,
          speakerid: item.speakerid.toString(),
          value: item.speakerid.toString(),
        };
        speakerOptions.push(obj);
      });
    }

    if (allSponsors && allSponsors.data && allSponsors.data.length > 0) {
      allSponsors.data.forEach((item, index) => {
        var obj = {
          label: `${item.name}`,
          sponsorid: item.sponsorid.toString(),
          value: item.sponsorid.toString(),
        };
        sponsorOptions.push(obj);
      });
    }

    if (allExhibitors && allExhibitors.data && allExhibitors.data.length > 0) {
      allExhibitors.data.forEach((item, index) => {
        var obj = {
          label: `${item.name}`,
          exhibitorid: item.exhibitorid.toString(),
          value: item.exhibitorid.toString(),
        };
        exhibitorOptions.push(obj);
      });
    }

    var spearkerStatus = false;
    var sponsorStatus = false;
    var exhibitorStatus = false;
    if (availableFeatures && availableFeatures.length > 0) {
      var speakerFeature = _.filter(availableFeatures, (obj) => {
        return obj.bsClass == "speaker";
      });
      var sponsorFeature = _.filter(availableFeatures, (obj) => {
        return obj.bsClass == "sponsor";
      });
      var exhibitorFeature = _.filter(availableFeatures, (obj) => {
        return obj.bsClass == "exhibitor";
      });

      if (
        speakerFeature &&
        speakerFeature.length > 0 &&
        speakerFeature[0]["isenabled"] == true
      )
        spearkerStatus = true;

      if (
        sponsorFeature &&
        sponsorFeature.length > 0 &&
        sponsorFeature[0]["isenabled"] == true
      )
        sponsorStatus = true;

      if (
        exhibitorFeature &&
        exhibitorFeature.length > 0 &&
        exhibitorFeature[0]["isenabled"] == true
      )
        exhibitorStatus = true;
    }

    return (
      <div className="basicform">
        {spearkerStatus == true ? (
          <Field
            name="speakeridfk"
            label={LocaleStrings.user_form_label_speaker}
            placeholder={LocaleStrings.user_form_label_speaker_placeholder}
            component={this.renderAutoComplete}
            mandatory="false"
            options={speakerOptions}
            labelKey="name"
            valueKey="speakerid"
            value={speakerValue}
          />
        ) : null}

        {sponsorStatus == true ? (
          <Field
            name="sponsoridfk"
            label={LocaleStrings.user_form_label_sponsor}
            placeholder={LocaleStrings.user_form_label_sponsor_placeholder}
            component={this.renderAutoComplete}
            mandatory="false"
            options={sponsorOptions}
            labelKey="name"
            valueKey="sponsorid"
            value={sponsorValue}
          />
        ) : null}

        {exhibitorStatus == true ? (
          <Field
            name="exhibitoridfk"
            label={LocaleStrings.user_form_label_exhibitor}
            placeholder={LocaleStrings.user_form_label_exhibitor_placeholder}
            component={this.renderAutoComplete}
            mandatory="false"
            options={exhibitorOptions}
            labelKey="name"
            valueKey="exhibitorid"
            value={exhibitorValue}
          />
        ) : null}
      </div>
    );
  }
}

class UserBadge extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedTemplateId: "",
      htmlData: "",
      loading: true,
      badgeLoad: true,
    };
  }

  componentDidMount() {
    var { session, initialValues } = this.props;
    // console.log("initialValues :- ", initialValues);

    // Fetch Badge Designer List For table
    this.props.fetchAllBadgeList(session, (response) => {
      // console.log("response :- ", response);

      if (response && response.data && response.data.length > 0) {
        let currentTemplateId = response.data[0].badgeid;

        this.setState({
          selectedTemplateId: currentTemplateId,
          loading: true,
          badgeLoad: true,
        });

        let dataObject = {
          appuserid: initialValues.appuserid,
          templateid: currentTemplateId,
          requesttype: "generateSingle",
        };

        /* API call Generate badge pdf to create pdf  */
        this.props.generateBadges(session, dataObject, (callback) => {
          // console.log("callback :- ", callback);

          this.setState({ loading: false, badgeLoad: false });
          if (callback.success === 0) {
            this.props.showError(COMMON_FAIL_MESSAGE);
          } else {
            this.setState({ htmlData: callback.htmlcontent });
          }
        });

        // setTimeout(() => {
        //   this.generateSingleBadge("preview");
        //   this.setState({ loading: false, badgeLoad: false });
        // }, 1000);
      } else {
        this.setState({ loading: false, badgeLoad: false });
      }
    });
  }

  tagToNameFc = (tagData, userVAl) => {
    let tagName = tagData.name;
    // console.log("tagName :- ", tagName);
    // console.log("userVAl :- ", userVAl);
    var generatedVal = "";
    if (tagName === "#event_name") {
      generatedVal = userVAl.eventname;
    } else if (tagName === "#event_location") {
      generatedVal = userVAl.country;
    } else if (tagName === "#full_name") {
      generatedVal = userVAl.username;
    } else if (tagName === "#first_name") {
      generatedVal = userVAl.firstname;
    } else if (tagName === "#last_name") {
      generatedVal = userVAl.lastname;
    } else if (tagName === "#company_name") {
      let jsonData = JSON.parse(userVAl.responses);
      let match = _.filter(jsonData, (obj) => {
        return obj.name === "company";
      });
      let company = match.length > 0 && match[0].value ? match[0].value : "";

      generatedVal = company;
    } else if (tagName === "#designation") {
      let jsonData = JSON.parse(userVAl.responses);
      let match = _.filter(jsonData, (obj) => {
        return obj.name === "designation";
      });
      let designation =
        match.length > 0 && match[0].value ? match[0].value : "";

      generatedVal = designation;
    } else if (tagName === "#registration_type") {
      let regType =
        userVAl.comesfrom === "admin_panel"
          ? "Admin"
          : userVAl.comesfrom === "ticket"
          ? "Ticket"
          : userVAl.comesfrom === "api"
          ? "Api"
          : userVAl.comesfrom === "open_registration"
          ? "Open Registration"
          : userVAl.comesfrom === "proposal"
          ? "Abstract"
          : "N/A";

      generatedVal = regType;
    } else if (tagName === "#primary_group") {
      let associated = _.split(userVAl.usercategory_name, ",");

      generatedVal = associated.length > 0 ? associated[0] : "-";
    } else {
      if (
        tagData.iscustom === true &&
        tagData.htmlType === "input" &&
        tagData.textValue
      ) {
        if (
          tagData.textValue.indexOf("{{") > -1 &&
          tagData.textValue.indexOf("}}") > -1
        ) {
          let rep = tagData.textValue.replace(/[{}]/g, "").trim();
          // console.log("rep :- ", rep);
          let jsonData = JSON.parse(userVAl.responses);
          // console.log("jsonData :- ", jsonData);
          let match = _.filter(jsonData, (obj) => {
            return obj.name == rep;
          });
          // console.log("match :- ", match);
          let customVal = "";

          if (match.length > 0) {
            let key = match[0].key;
            if (key !== "hyperlink" && key !== "label" && key !== "paragraph") {
              let value = match[0].value ? match[0].value : "";
              // console.log("value :-", value);
              if (key === "checkboxes" && Array.isArray(value)) {
                let options = match[0].options;
                let matchedVal = [];

                value.forEach((element) => {
                  let m = _.filter(options, (o) => {
                    return o.text === element || o.value === element;
                  });
                  if (m.length > 0) {
                    matchedVal.push(m[0].text);
                  }
                });

                customVal = matchedVal.join(", ");
              } else if (
                (key === "dropdown" || key === "radiobuttons") &&
                value !== ""
              ) {
                let options = match[0].options;

                let m = _.filter(options, (o) => {
                  return o.text === value || o.value === value;
                });
                if (m.length > 0) {
                  customVal = m[0].text;
                }
              } else if (key === "datepicker" && value !== "") {
                customVal = moment(value).format(DISPLAY_LOCAL_DATE_FORMAT);
              } else {
                customVal = value;
              }
            }
          }

          generatedVal = customVal;
        } else {
          generatedVal = tagData.textValue;
        }
      } else {
        generatedVal = tagName;
      }
    }

    return generatedVal;
  };

  // Generating single badge locally
  generateSingleBadge = (action = "print") => {
    let { badgeList, initialValues, eventDetails } = this.props;
    let currentTemplateId = this.state.selectedTemplateId;
    var selectedUsers = [initialValues];
    // console.log("selectedUsers :- ", selectedUsers);

    var selcted = _.filter(badgeList.data, (obj) => {
      return obj.badgeid == currentTemplateId;
    });
    var selctedBadge = selcted[0];
    // console.log("selctedBadge - ", selctedBadge);

    var badgeSize = selctedBadge.badge_size;
    var templateData = JSON.parse(selctedBadge.template); // String to json parse for template
    templateData.reverse(); // Only for z-index, as last element in array will be in last indexing;
    // console.log("templateData - ", templateData);

    // Get badhe size (W * H)
    var badgeSizeArray = _.split(badgeSize, "#");
    var boxWidth = parseFloat(
      convertToPixel(selctedBadge.measurement, badgeSizeArray[0])
    );
    var boxHeight = parseFloat(
      convertToPixel(selctedBadge.measurement, badgeSizeArray[1])
    );

    var orientation = "p";
    if (boxWidth > boxHeight) {
      orientation = "l";
    }
    const doc = new jsPDF(orientation, "pt", [boxWidth, boxHeight]);

    var allqrDataArr = [];
    var promiseArray = [];
    _.forEach(selectedUsers, (user, index) => {
      promiseArray.push(
        new Promise(async (resolve, reject) => {
          var magicurlqr = user.userqrstring;
          var qrdata = await QRCode.toDataURL(magicurlqr, {
            margin: 0,
          });
          allqrDataArr.push(qrdata);
          resolve();
        })
      );
    });

    let fileImported = [];
    Promise.all(promiseArray).then(() => {
      // console.log("allqrDataArr", allqrDataArr);

      _.forEach(selectedUsers, (user, index) => {
        user.eventname = eventDetails.eventname;
        user.eventicon = eventDetails.eventicon;
        user.country = eventDetails.country;
        var eventlogowidth = 50;
        var eventlogohight = 50;
        var qrwidth = 50;
        var qrhight = 50;
        var customimagewidth = boxWidth;
        var customimagehight = boxHeight;
        var mylink = allqrDataArr[index];

        _.forEach(templateData, (template) => {
          // console.log("template :- ", template);
          var fontsize = DEFAULTFONTSIZE.replace(/\D/g, "");
          var fontweight = DEFAULTFONTWEIGHT;
          var fontfamily = DEFAULTFONTFAMILY;
          var fontstyle = "";
          var textdecoration = "";
          var texttransform = "none";
          var textcolor = "#000000";

          var templateX = template.x / 2;
          var templateY = template.y / 2;

          // Only show those which hidden key value is 'false' in json
          if (!template.hidden) {
            var ismiddle = 0;
            // console.log("template :- ", template);

            // Check the style set for current field
            _.forEach(template.style, (stylevalue, styleKey) => {
              var stVal = "";
              if (
                stylevalue !== null &&
                stylevalue !== "null" &&
                stylevalue !== "" &&
                styleKey !== "border"
              ) {
                if (
                  template.htmlType === "div" ||
                  template.htmlType === "input"
                ) {
                  if (styleKey === "fontSize") {
                    stVal = stylevalue.replace(/\D/g, ""); // replace pxfrom style value to divide by 2
                    fontsize = stVal / 2;
                  } else {
                    stVal = stylevalue;
                  }

                  if (styleKey === "fontWeight") {
                    fontweight = stVal;
                  }
                  if (styleKey === "fontFamily") {
                    fontfamily = stVal;
                  }
                  if (styleKey === "fontStyle") {
                    fontstyle = stVal;
                  }
                  if (styleKey === "textDecoration") {
                    textdecoration = stVal;
                  }
                  if (styleKey === "textTransform") {
                    texttransform = stVal;
                  }
                  if (styleKey === "color") {
                    textcolor = stVal;
                  }
                  if (styleKey === "textAlign" && stylevalue === "center") {
                    templateX = 0;
                    ismiddle = 1; // -> JS PART
                  }
                } else {
                  if (styleKey === "width" || styleKey === "height") {
                    stVal = stylevalue / 2;

                    if (styleKey === "width") {
                      if (template.name === "#qr_code") {
                        qrwidth = stVal;
                      }
                      if (template.name === "#event_logo") {
                        eventlogowidth = stVal;
                      }
                      if (template.iscustom && template.htmlType === "image") {
                        customimagewidth = stVal;
                      }
                    }

                    if (styleKey === "height") {
                      if (template.name === "#qr_code") {
                        qrhight = stVal;
                      }
                      if (template.name === "#event_logo") {
                        eventlogohight = stVal;
                      }
                      if (template.iscustom && template.htmlType === "image") {
                        customimagehight = stVal;
                      }
                    }
                  } else {
                    stVal = stylevalue;
                  }
                }
              }
            });

            // FOR EVENT LOG
            if (template.name === "#event_logo") {
              var event_log_src = `${BASE_IMAGES_URL}/${user.eventicon}?api_key=${ACCESS_FILES_API_KEY}`;
              let imgData = event_log_src;

              doc.addImage(
                imgData,
                "JPEG",
                templateX,
                templateY,
                eventlogowidth,
                eventlogohight
              );
            } else if (template.iscustom && template.htmlType === "image") {
              var customimage = `${BASE_IMAGES_URL}/${template.imageValue}?api_key=${ACCESS_FILES_API_KEY}`;
              let imgData = customimage;

              doc.addImage(
                imgData,
                "JPEG",
                templateX,
                templateY,
                customimagewidth,
                customimagehight
              );
            } else if (template.name === "#qr_code") {
              var magicurlqr = user.userqrstring;
              // var mylink = `${INSTANCE_URL}/qrcode.php?s=qr&d=${magicurlqr}&sf=10&ms=r&md=1&wq=0&h=500&w=500`;
              let imgData = mylink;
              // console.log("imgData :- ", imgData);

              doc.addImage(
                imgData,
                "JPEG",
                templateX,
                templateY,
                qrwidth,
                qrhight
              );
            } else if (template.htmlType === "input") {
              // For any input type
              let getVal = this.tagToNameFc(template, user);
              let textVal =
                texttransform == "uppercase" ? getVal.toUpperCase() : getVal;
              // let textVal =
              //   texttransform == "uppercase"
              //     ? template.textValue.toUpperCase()
              //     : template.textValue;

              if (fontfamily == "Helvetica") {
                doc.setFont(`${fontfamily}`, `${fontstyle}`, `${fontweight}`);
              } else {
                let fontFile = "Normal";
                if (fontweight === "bold") {
                  fontFile = "Bold";
                }
                if (fontstyle === "italic") {
                  fontFile = `${fontFile}Italic`;
                }

                let fontFileName = `${fontfamily}-${fontFile}`;
                if (!_.includes(fileImported, fontFileName)) {
                  fileImported.push(fontFileName);
                  let importFont = `${MAIN_URL}/assets/fonts/${fontFileName}.ttf`;
                  doc.addFont(`${importFont}`, `${fontfamily}`, "normal");
                }
                doc.setFont(`${fontfamily}`);
              }
              doc.setFontSize(fontsize);
              doc.setTextColor(`${textcolor}`);

              if (ismiddle == 1) {
                let getPageWidth =
                  doc.internal.pageSize.width ||
                  doc.internal.pageSize.getWidth();
                doc.text(`${textVal}`, getPageWidth / 2, templateY + fontsize, {
                  align: "center",
                  maxWidth: getPageWidth,
                });
              } else {
                doc.text(`${textVal}`, templateX, templateY + fontsize);
              }
            } else {
              let getVal = this.tagToNameFc(template, user);
              let textVal =
                texttransform == "uppercase" ? getVal.toUpperCase() : getVal;

              if (fontfamily == "Helvetica") {
                doc.setFont(`${fontfamily}`, `${fontstyle}`, `${fontweight}`);
              } else {
                let fontFile = "Normal";
                if (fontweight === "bold") {
                  fontFile = "Bold";
                }
                if (fontstyle === "italic") {
                  fontFile = `${fontFile}Italic`;
                }

                let fontFileName = `${fontfamily}-${fontFile}`;
                if (!_.includes(fileImported, fontFileName)) {
                  fileImported.push(fontFileName);
                  let importFont = `${MAIN_URL}/assets/fonts/${fontFileName}.ttf`;
                  doc.addFont(`${importFont}`, `${fontfamily}`, "normal");
                }
                doc.setFont(`${fontfamily}`);
              }
              doc.setFontSize(fontsize);
              doc.setTextColor(`${textcolor}`);

              if (ismiddle == 1) {
                let getPageWidth =
                  doc.internal.pageSize.width ||
                  doc.internal.pageSize.getWidth();
                doc.text(`${textVal}`, getPageWidth / 2, templateY + fontsize, {
                  align: "center",
                  maxWidth: getPageWidth,
                });
              } else {
                doc.text(`${textVal}`, templateX, templateY + fontsize);
              }
            }
          }
        });

        if (selectedUsers.length - 1 > index) {
          doc.addPage([boxWidth, boxHeight], orientation);
        }
      });
      if (action === "print") {
        doc.save(`${selectedUsers[0].firstname}.pdf`);
      } else {
        // this is dummy image as without image badge in not allowing to show as pdfObject
        doc.addImage("../../style/images/yellowstar.png", "PNG", 0, 0, -1, -1);
        let blobUrl = doc.output("bloburl");
        // console.log("blobUrl :- ", blobUrl);

        PDFObject.embed(blobUrl, "#preview-panel");
      }
    });
  };

  selectTemplate = (badge) => {
    var { session, initialValues } = this.props;
    let currentTemplateId = badge.target.value;
    this.setState({ selectedTemplateId: currentTemplateId, badgeLoad: true });

    // Return if template is selected blank
    if (currentTemplateId === "") {
      return true;
    } else {
      let dataObject = {
        appuserid: initialValues.appuserid,
        templateid: currentTemplateId,
        requesttype: "generateSingle",
      };

      /* API call Generate badge pdf to create pdf  */
      this.props.generateBadges(session, dataObject, (callback) => {
        this.setState({ badgeLoad: false });
        if (callback.success === 0) {
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.setState({ htmlData: callback.htmlcontent });
        }
      });

      // setTimeout(() => {
      //   this.generateSingleBadge("preview");
      //   this.setState({ badgeLoad: false });
      // }, 1000);
    }
  };

  render() {
    var { badgeList } = this.props;
    var { loading, badgeLoad, htmlData } = this.state;
    // console.log("badgeList :- ", badgeList);

    var badgeTemplates = [];
    if (badgeList && badgeList.data && badgeList.data.length > 0) {
      badgeList.data.forEach((item, index) => {
        var obj = {
          name: item.badgename,
          value: item.badgeid,
        };
        badgeTemplates.push(obj);
      });
    }

    let boxWidth = "auto";
    let boxHeight = "auto";

    return (
      <div>
        {loading === true ? (
          <div className="loader-container mt-15">
            <Loader />
          </div>
        ) : (
          <>
            <label className="control-label-top">{LocaleStrings.badge}</label>
            <select
              className="form-control dropdown-height-border"
              onChange={this.selectTemplate}
            >
              {badgeTemplates.map((object, index) => {
                return (
                  <option key={`${object.value}-${index}`} value={object.value}>
                    {object.name}
                  </option>
                );
              })}
            </select>
            {badgeLoad ? (
              <div className="loader-container mt-15">
                <Loader />
              </div>
            ) : (
              <>
                <div className="badge-view-container custom-align-center mt-15 mb-15">
                  <div
                    className="badge-view"
                    id="preview-panel"
                    style={{ width: boxWidth, height: boxHeight }}
                    dangerouslySetInnerHTML={{ __html: htmlData }}
                  ></div>
                </div>
                <button
                  type="button"
                  className="btn btn-custom-blue"
                  onClick={() => this.generateSingleBadge("print")}
                >
                  {LocaleStrings.button_print}
                </button>
              </>
            )}
          </>
        )}
      </div>
    );
  }
}

class UserEmailList extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    var { session, initialValues } = this.props;

    if (initialValues.event_email_logs_by_appuserid) {
      this.setState({ loading: false });
    }
  }

  renderemailList() {
    let { initialValues } = this.props;
    var items = _.map(
      initialValues?.event_email_logs_by_appuserid,
      (logdata) => (
        <ListItem key={logdata.logid} logdata={logdata} callfrom={"users"} />
      )
    );
    return items;
  }

  render() {
    var { initialValues } = this.props;
    var { loading } = this.state;

    return (
      <div>
        {loading === true ? (
          <div className="loader-container mt-15">
            <Loader />
          </div>
        ) : (
          <>
            <div className="scrollable-content">
              <table className="table">
                <thead>
                  <tr>
                    <th style={{ width: "20%" }}>
                      {LocaleStrings.th_receiver_EmailLog}
                    </th>
                    <th style={{ width: "10%" }}>
                      {LocaleStrings.th_datetime_EmailLog}
                    </th>
                    <th style={{ width: "10%" }}>
                      {LocaleStrings.th_logfrom_EmailLog}
                    </th>
                    {/* <th>{LocaleStrings.th_finalstatus_EmailLog}</th> */}
                    <th style={{ width: "45%" }}>
                      {LocaleStrings.th_statusfromlogs_EmailLog}
                    </th>
                    <th style={{ width: "15%" }}>
                      {LocaleStrings.th_content_EmailLog}
                    </th>
                  </tr>
                </thead>
                <tbody className="tbody-background">
                  {this.renderemailList()}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    );
  }
}
